/**
 * Per-type view registrations (GDN-2723, GDN-2726).
 *
 * `resource_type` → the slots that type fills. A type with no entry renders
 * entirely from the shell + its JSON Schema, which is why newly registered
 * backend resource types are browsable the day they land without any frontend
 * change. Registering here is an upgrade, never a prerequisite.
 */

import { appointmentView } from './definitions/appointment-view';
import {
  claimView,
  documentReferenceView,
  encounterTypeView,
  patientView,
} from './definitions/browse-views';
import { encounterView } from './definitions/encounter-view';
import { noteView } from './definitions/note-view';
import { transcriptionView } from './definitions/transcription-view';
import type { ResourceViewDefinition } from './types';

const RESOURCE_VIEWS: Record<string, ResourceViewDefinition> = {
  appointment: appointmentView,
  encounter: encounterView,
  note: noteView,
  transcription_session: transcriptionView,
  // Browse-only: columns and a label, no bespoke detail (GDN-2729).
  claim: claimView,
  document_reference: documentReferenceView,
  encounter_type: encounterTypeView,
  patient: patientView,
};

export function getResourceView(
  resourceType: string,
): ResourceViewDefinition | undefined {
  return RESOURCE_VIEWS[resourceType];
}

/** Display label for a type, falling back to the raw registry name. */
export function resourceLabel(resourceType: string): string {
  return RESOURCE_VIEWS[resourceType]?.label ?? resourceType;
}
